'use client';

import { VStack } from '@terra/ui-styled-system';
import { useTranslations } from 'next-intl';
import { Button } from '../../../components/button';
import { BodyStrong, MetaDefault } from '../../../components/typography';
import { SettingsCard } from '../../settings/SettingsCard';

export type InventoryNotConnectedCardProps = {
  title: string;
  description: string;
  onOpenIntegrations: () => void;
};

export function InventoryNotConnectedCard({
  title,
  description,
  onOpenIntegrations,
}: InventoryNotConnectedCardProps) {
  const tShared = useTranslations(
    'designSystem.networkSettings.externalInventory.shared',
  );

  return (
    <SettingsCard>
      <VStack alignItems="flex-start" gap={2}>
        <BodyStrong>{title}</BodyStrong>
        <MetaDefault color="fg.neutral.subtle">{description}</MetaDefault>
        <Button variant="outline" size="sm" onClick={onOpenIntegrations}>
          {tShared('goToIntegrations')}
        </Button>
      </VStack>
    </SettingsCard>
  );
}
